import React, { Suspense, useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout copy";
import GeneralLoader from "../Components/UI/GeneralLoader";
import { RoutesRenderer } from "./RouterRenderer";
import { authRoutes, privateRoutes, } from "./RouteList";
// import { StorageKeys } from "../Configs/Storage";
import AuthRoute from "~/Components/CustomRoutes/Partials/AuthRoute";
import PrivateRoute from "~/Components/CustomRoutes/Partials/PrivateRoute";
// import useProducts from "../Hooks/useProducts";
// import { setProducts } from "../store/app/Product";
import { useDispatch, useSelector } from "react-redux";
// import { setProducts } from "./Product";
import withReducer from "../store/withReducer";
// import { useSelector } from "react-redux";
// export default withReducer("productTest", product)(HomePage)
// import product, { setProducts } from '../store/ProductTestSlice'

// export default function AppRoutes() {
function AppRoutes() {
  // const app = useSelector((state) => state?.app)
  // const productTest = useSelector((state) => state?.productTest?.data)
  // let user = useSelector((state) => state?.app?.user)
  // const dispatch = useDispatch();
  // const { isRefetching, isLoading, products } = useProducts();


  useEffect(() => {
    // const products = productTest?.length > 0 ? productTest : []
    // console.log('products', productTest)
    // dispatch(setProducts({ payload: products }));
    // dispatch(setProducts({ payload: products }));
    // const data = user?.data ? user?.data : userContextObj.data;
    // const isAuthenticated = user?.isAuthenticated ? user?.isAuthenticated : userContextObj.isAuthenticated;
    // const token = user?.token ? user?.token : userContextObj?.token;
    // const role = user?.role ? user?.role : []
    // const role = [{ permissions: [{ name: "iran" }] }]
    // setUserContext({
    //   data,
    //   token,
    //   isAuthenticated,
    //   role,
    // });
    // const theme = app?.theme ? app?.theme : "light";
    // const locale = app?.locale ? app?.locale : "en";
    // const direction = app?.direction ? app?.direction : "ltr";
    // setAppContext({ theme, locale, direction });
  }, [])

  return (
    <Suspense fallback={<GeneralLoader />}>
      <Routes>
        <Route>
          {RoutesRenderer(authRoutes, AuthRoute)}
        </Route>
        <Route>
          <Route
            element={
              <Layout>
                <Outlet />
              </Layout>
            }
          >
            {RoutesRenderer(privateRoutes, PrivateRoute)}
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}

// export default withReducer("productTest", product)(AppRoutes)
export default AppRoutes